import { getField, updateField } from "vuex-map-fields";

const initialState = () => ({
  currentRoute: "/home",
});

export const state = initialState();

export const getters = {
  getField,
  currentRoute(state) {
    return state.currentRoute;
  },
};

export const actions = {
  saveRoute({ commit }, route) {
    commit("updateField", { path: "currentRoute", value: route });
  },
};

export const mutations = {
  updateField,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
